// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2j7hD","requiredAsterisk":"Info_requiredAsterisk__P5Xds"};